<template>
  <multipurpose-image-banner
    class="mib--manager-card"
    :fields="mappedFields"
    :rendering="rendering"
    :params="params"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import MultipurposeImageBanner from '../MultipurposeImageBanner/MultipurposeImageBanner.vue';
import type {
  BusinessDevelopmentManagerCardProps,
  BusinessDevelopmentManagerCardFields,
} from './types';

const props = withDefaults(defineProps<BusinessDevelopmentManagerCardProps>(), {
  fields: () => ({}) as BusinessDevelopmentManagerCardFields,
  params: () => ({}),
});

const mappedFields = computed(() => {
  return {
    heading: props.fields.businessDevelopmentManagerName,
    subheading: props.fields.businessDevelopmentManagerJobTitle,
    description: props.fields.summaryPubComments?.value
      ? { value: `‘${props.fields.summaryPubComments.value}’` }
      : null,
    imageDesktop: props.fields.businessDevelopmentManagerPhoto,
  };
});
</script>
